<template>
  <v-container container--fluid fill-height style="background: #e6e6fc;">
    <v-row align="start" justify="center">
      <v-col cols="12" sm="6" md="6" lg="5" xl="5" v-if="order">
        <v-stepper
          v-model="st"
          class="ra-2"
          style="
                    border-top: 5px solid #7f79d9;
                    border-bottom: 5px solid #7f79d9;
                    box-shadow: 0px 0px 27px 5px rgba(2, 2, 2, 0.096) ;
              "
        >
          <v-stepper-items>
            <v-stepper-content step="1">
              <div class>
                <v-img
                  height="60"
                  contain
                  src="https://cdn.siap.id/s3/masook/asset img/SIM/logo.png"
                  aspect-ratio="1"
                ></v-img>
              </div>
              <v-card flat text class="pa-5 elevation-0">
                <v-card-title primary-title class="justify-space-around">
                  <span
                    class="title primary--text d-block text-center font-weight-bold"
                    >Informasi Pembayaran</span
                  >
                </v-card-title>
                <v-card-text>
                  <v-row column wrap>
                    <v-col cols="12">
                      <v-simple-table>
                        <template v-slot:default>
                          <tbody>
                            <tr>
                              <td>Nama Instansi</td>
                              <td class="font-weight-bold">
                                {{ order.nama }}
                              </td>
                            </tr>
                            <tr>
                              <td>Jenis Pesanan</td>
                              <td class="font-weight-bold">
                                {{
                                  order.k_jenis_pesanan == 1
                                    ? "Berlangganan Baru"
                                    : order.k_jenis_pesanan == 2
                                    ? "Perpanjangan"
                                    : "Tambah Kuota"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <td>Total Kuota</td>
                              <td class="font-weight-bold">
                                {{ order.kuota }}
                              </td>
                            </tr>
                            <tr>
                              <td>Status Pembayaran</td>
                              <td class="font-weight-bold">
                                <v-chip
                                  :class="
                                    Number(order.is_bayar) === 1
                                      ? 'success success--text'
                                      : 'orange orange--text'
                                  "
                                  outlined
                                  >{{
                                    Number(order.is_bayar) === 1
                                      ? "Sudah dibayar" :
                                      Number(order.is_bayar) === 2
                                      ? "Jatuh Tempo"
                                      : "Belum Dibayar"
                                  }}</v-chip
                                >
                              </td>
                            </tr>

                            <tr>
                              <td>Batas Waktu Pembayaran</td>
                              <td class="font-weight-bold red--text">
                                {{ order.batas_bayar | toDT }}
                              </td>
                            </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                    <v-col cols="12" class=" ml-3" v-if="order.total">
                      <p>Rincian Pembayaran</p>
                      <v-row no-gutters>
                        <v-col cols="6">Layanan Masook</v-col>
                        <v-col cols="6" class="text-right">
                          &nbsp;Rp {{ order.harga | toC }}
                        </v-col>
                        <v-col v-if="order && order.potongan_harga" cols="6">Voucher</v-col>
                        <v-col v-if="order && order.potongan_harga" cols="6" class="text-right">
                          - Rp {{ order.potongan_harga | toC }}
                        </v-col>
                        <v-col cols="6">PPN 11%</v-col>
                        <v-col cols="6" class="text-right">
                          &nbsp;Rp {{ order.ppn | toC }}
                        </v-col>
                        <v-col cols="6">Admin Layanan</v-col>
                        <v-col cols="6" class="text-right">
                          &nbsp;Rp {{ order.biaya_admin | toC }}
                        </v-col>
                        <v-col cols="6" class="pt-4 font-weight-bold">
                          Total Pembayaran
                        </v-col>
                        <v-col cols="6" class="text-right pt-4 font-weight-bold">
                          &nbsp;Rp {{ order.total | toC }}
                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col>
                      <br />
                      <br />
                      <div
                        class="indigo lighten-5 pa-3  black&#45;&#45;text text-center"
                      >
                        <p class="mb-0 pb-0">Kode Pembayaran</p>
                        <span
                          class="display-1 primary--text font-weight-bold"
                          >{{ order.kode_bayar }}</span
                        >
                      </div>
                      <p class="caption grey--text pt-3 font-italic">
                        * Biaya sudah termasuk biaya Pajak PPN 11% dan Biaya
                        Admin layanan
                      </p>
                    </v-col>
                    <v-col cols="12">
                      <m-button
                        is-block
                        class="ma-2"
                        text="Oke"
                        large
                        color="primary"
                        action="onConfirm"
                        @onConfirm="$router.push({ name: 'billing' })"
                      ></m-button>
                    </v-col>
                    <v-col cols="12" md="12" sm="12" class="text-center">
                      <v-layout justify-center align-center>
                        <v-flex shrink>
                          <div class="text-caption">didukung oleh</div>
                          <v-img
                            class="mx-auto"
                            src="https://cdn.siap.id/s3/masook/asset%20img/portal/pembayaran/logo%20Finpay%20SAH%20(1).png"
                            width="100px"
                          />
                        </v-flex>
                      </v-layout>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                </v-card-actions>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-col>
      <v-col cols="12" sm="6" md="6" lg="5" xl="5" class="align-start">
        <v-card flat class="pa-5 transparent">
          <p class="font-weight-bold">
            Berikut adalah tata cara melakukan proses pembayaran layanan Masook
            :
          </p>
          <v-row class="ma-1">
            <v-expansion-panels accordion>
              <v-expansion-panel v-for="(item, i) in mPembayaran" :key="i">
                <v-expansion-panel-header>
                  <v-row>
                    <v-col cols="2" class="pa-0"
                      ><img width="100%" :src="item.img" />
                    </v-col>
                    <v-col cols="10" class="pa-0 pl-5 title">{{
                      item.label
                    }}</v-col>
                  </v-row>
                </v-expansion-panel-header>
                <v-expansion-panel-content style="font-size:11pt">
                  <template v-if="item.pembayarans">
                    <v-row justify="center" class="nshadow">
                      <v-expansion-panels
                        accordion
                        class="nshadow"
                        elevation="0"
                      >
                        <v-expansion-panel
                          v-for="(panduan, p) in item.pembayarans"
                          :key="p"
                          class="nshadow"
                        >
                          <v-expansion-panel-header>{{
                            panduan.label
                          }}</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <ol
                              type="1"
                              style="line-hight:22px; font-size:10pt"
                            >
                              <li
                                v-for="(desc, d) in panduan.deskripsi"
                                :key="d"
                                v-html="desc"
                              />
                            </ol>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-row>
                  </template>
                  <template v-else>
                    <v-row class="nshadow">
                      <div class="mb-2">
                        {{ item.subtitle || "ATM (dalam Bahasa Indonesia)" }}
                      </div>
                      <ol type="1" style="line-hight:22px; font-size:10pt">
                        <li
                          v-for="(desc, d) in item.deskripsi"
                          :key="d"
                          v-html="desc"
                        />
                      </ol>
                    </v-row>
                  </template>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { API, SIM } from "@/const";
import axios from "axios";
import Progress from "@/components/CompProgress";
import { format } from "date-fns";
import { pembayaran } from "@/config";

export default {
  components: {
    Progress
  },
  data() {
    return {
      st: 1,
      order: null,
      loading: false,
      kode: null,
      mPembayaran: pembayaran
    };
  },
  activated() {
    this.checkQuery();
  },
  methods: {
    checkQuery() {
      if (this.$route.params.kode_pembayaran) {
        // langsung lakukan verifikasi
        this.$nextTick(() => {
          this.verify(this.$route.params.kode_pembayaran);
        });
      } else {
        this.$error("Kode Pembayaran tidak valid");
      }
    },

    toAktivasi() {
      if (this.order && this.order.aktivasi) {
        window.open(SIM + "/#/aktivasi", "_blank");
      }
    },

    verify(kode_pembayaran) {
      this.loading = true;
      axios
        .get(`${API}/order/${kode_pembayaran}`)
        .then(res => {
          this.loading = false;
          this.order = { ...res.data.data };
        })
        .catch(e => {
          if (e) {
            this.$error(e.response.data.message);
          }
          this.loading = false;
        });
    },

    currency(data, n, x, s, c) {
      let re = "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\D" : "$") + ")",
        num = Number(data).toFixed(Math.max(0, ~~n));

      return (c ? num.replace(",", c) : num).replace(
        new RegExp(re, "g"),
        "$&" + (s || ".")
      );
    }
  },
  computed: {
    tanggalOrder() {
      if (this.order && this.order.batas_bayar) {
        return format(new Date(this.order.batas_bayar), "dd-MM-yyyy HH:mm");
      } else {
        return 0;
      }
    }
  }
};
</script>
<style scoped lang="css">
@media only screen and (min-width: 960px) {
  .container {
    max-width: 1020px !important;
  }
}
.nshadow {
  -webkit-box-shadow: 0px !important;
  box-shadow: 0px !important;
}
</style>
